export default "__VITE_ASSET__ddd68cb6__"